@if (options.type! !== 'text') {
  <div class="loading-default__icon">
    @switch (options.type) {
      @case ('spin') {
        <nz-spin nzSimple />
      }
      @case ('icon') {
        <nz-icon [nzType]="icon.type!" [nzTheme]="icon.theme!" [nzSpin]="icon.spin" />
      }
      @default {
        <div class="loading-default__custom" [style]="custom.style!" [innerHTML]="custom.html"></div>
      }
    }
  </div>
}
@if (options.text) {
  <div class="loading-default__text">{{ options.text }}</div>
}
